/**
 * Field name mapping for user-friendly labels
 * Maps API field names to display names shown to users
 */
export const FIELD_LABELS = {
  vin: "Chassis Number",
  // Add more field mappings here as needed
  // Example:
  // battery_id: "Battery ID",
  // vehicle_id: "Vehicle ID",
};

/**
 * Translates API field names to user-friendly labels in error messages
 * @param {string} message - The error message from API
 * @returns {string} - Translated error message with user-friendly field names
 *
 * @example
 * translateErrorMessage("vin must be exactly 17 characters long")
 * // Returns: "Chassis Number must be exactly 17 characters long"
 */
export const translateErrorMessage = (message) => {
  if (!message || typeof message !== 'string') return message;

  let translatedMessage = message;
  Object.entries(FIELD_LABELS).forEach(([fieldName, label]) => {
    const regex = new RegExp(`\\b${fieldName}\\b`, 'gi');
    translatedMessage = translatedMessage.replace(regex, label);
  });

  return translatedMessage;
};

/**
 * Gets the user-friendly label for a field name
 * @param {string} fieldName - The API field name
 * @returns {string} - User-friendly label or original field name if not found
 *
 * @example
 * getFieldLabel("vin") // Returns: "Chassis Number"
 * getFieldLabel("unknown_field") // Returns: "unknown_field"
 */
export const getFieldLabel = (fieldName) => {
  return FIELD_LABELS[fieldName] || fieldName;
};
